import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React, { FC, useRef, useState } from 'react';
import { SidebarProps } from './Sidebar.types';
import { STYLE_VARS } from '../../constants/style-vars';
import { Image } from '../Image';
import { Animated } from 'react-native';
import { useSelector } from 'react-redux';
import { RootState } from '../../services/redux';
import { NavigationService } from '../../services/navigation';

const Sidebar: FC<SidebarProps> = ({ data, current, handlePressItem }) => {
  const auth = useSelector((redux: RootState) => redux.authReducer);
  const [hover, setHover] = useState<string>('');
  const handleMouseEnter = (title: string) => {
    // setHover(true);
    setHover(title);
  };

  const handleMouseLeave = () => {
    setHover('');
  };
  return (
    <View>
      {data.map((item, index, arr) => (
        <div
          onMouseEnter={() => {
            handleMouseEnter(item.title);
          }}
          className={current !== index ? 'slidebar-item' : ''}
          onMouseLeave={handleMouseLeave}
          key={index}
        >
          <TouchableOpacity
            key={item.title}
            style={[
              {
                flexDirection: 'row',
                alignItems: 'center',
                backgroundColor:
                  current === index ? STYLE_VARS.primaryColor : undefined,
                padding: 10,
              },
            ]}
            onPress={() => {
              if (current !== index) {
                if (item.requiredLogin && !auth.loggedin) {
                  NavigationService.push('Login');
                } else {
                  if (item.onPress) item.onPress();
                }
              }
              if (handlePressItem) handlePressItem();
            }}
          >
            <Image
              source={item.icon}
              style={{
                width: 35,
                height: 32,
                tintColor:
                  current === index || hover === item.title
                    ? 'white'
                    : STYLE_VARS.textColor,
                resizeMode: 'contain',
              }}
            />
            <Text
              style={{
                color:
                  current === index || hover === item.title
                    ? 'white'
                    : STYLE_VARS.textColor,
                marginLeft: 20,
                textTransform: 'uppercase',
              }}
            >
              {item.title}
            </Text>
          </TouchableOpacity>
        </div>
      ))}
    </View>
  );
};

export default Sidebar;

const styles = StyleSheet.create({});
